"use client";

import { campingRentalDays } from "@/lib/mobility/camping-period";
import type { GearEntry } from "@/lib/mobility/camping-gear";
import { CampingGearGrid } from "./CampingGearGrid";
import { useHub } from "./hub-context";

/**
 * 캠핑 허브 [장비] 탭(09-29) — 캠핑장 시트와 **같은 장비 카드·가격·정렬**.
 *
 * 목록은 허브가 조립해 넘긴다(`lib/mobility/camping-gear`): 지점 목록과 같은 캠핑장
 * 집합의 장비(메모리, 즉시) + 허브에 없는 택배 장비(탭을 열 때 받아 뒤에 붙임).
 * 가격은 날짜를 골랐으면 그 기간 총액, 아니면 1박 2일 "~부터". 창 단위 렌더는
 * CampingGearGrid 가 맡는다.
 */
export function GearSheet({
  entries,
  pending,
}: {
  entries: readonly GearEntry[];
  /** 택배 장비를 받는 중 */
  pending: boolean;
}) {
  const { checkinDate, checkoutDate } = useHub();
  const rentalDays = campingRentalDays(checkinDate, checkoutDate);
  return (
    <div className="pt-2 pb-8">
      <CampingGearGrid entries={entries} rentalDays={rentalDays} pending={pending} />
    </div>
  );
}
